import { Controller } from 'stimulus';
import porta from 'porta';
import jump from 'jump.js';
import nl from 'porta/src/i18n/nl';
import en from 'porta/src/i18n/en';
import toArray from '@/helpers/toArray';
import universalTracking from '../tracking/universalTracking';

const messages = document.documentElement.lang === 'nl'
  ? nl
  : en;

class FormValidationController extends Controller {
  connect() {
    porta({
      target: this.element,
      messages,
      onValidate: (formElement) => {
        this.disableSubmitButton(formElement);
      },
      onError: (formElement) => {
        this.validateLocation(formElement);
        this.scrollToFirstError(formElement);
        this.enableSubmitButton(formElement);
      },
      onValid: (formElement) => {
        const validateLocation = this.validateLocation(formElement);

        if (!validateLocation) {
          this.scrollToFirstError(formElement);
          return false;
        }

        // Wait a few seconds before re-enabling the form. There
        // is time between the form being succesfully validated
        // and the request being completed. We don't want to allow
        // the user to perform form submissions during this time.
        setTimeout(() => {
          this.enableSubmitButton(formElement);
        }, 20000);

        return true;
      },
    });
  }

  disableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, false);
  }

  enableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, true);
  }

  // eslint-disable-next-line class-methods-use-this
  toggleSubmitButtonState(formElement, state) {
    toArray(formElement.querySelectorAll('[type="submit"]')).forEach((button) => {
      button[state ? 'removeAttribute' : 'setAttribute']('disabled', 'disabled');
    });
  }

  // eslint-disable-next-line class-methods-use-this
  scrollToFirstError(formElement) {
    const errors = toArray(formElement.querySelectorAll('.porta-error-message'));

    if (!errors.length) {
      return;
    }

    const firstError = errors[0];
    const firstErrorParent = firstError.parentNode;

    const headerElement = document.querySelector('.header');
    const headerHeight = headerElement ? headerElement.offsetHeight : 0;

    jump(firstErrorParent, {
      offset: headerHeight * -1,
    });

    const errorElements = toArray(formElement.querySelectorAll('.porta-error'))
      .map((errElement) => errElement.getAttribute('name')?.trim())
      .join(', ')
      .substr(0, 100);

    universalTracking.event('Form', 'errors', errorElements);
  }

  // eslint-disable-next-line class-methods-use-this
  validateLocation(formElement) {
    const locationField = formElement.querySelector('#location');

    if (!locationField) {
      return true;
    }

    const locationFieldValue = locationField.value;

    if (locationFieldValue) {
      return true;
    }

    const locationFieldParent = locationField.parentNode;

    const existingError = locationFieldParent.querySelector('.porta-error-message');

    if (existingError) {
      existingError.parentNode.removeChild(existingError);
    }

    const errorElement = document.createElement('div');
    errorElement.className = 'porta-error-message';
    errorElement.setAttribute('aria-live', 'assertive');
    errorElement.textContent = messages.valueMissing;

    locationFieldParent.appendChild(errorElement);

    return false;
  }
}

export default FormValidationController;
